import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductBackendServer extends BaseBackend {

  getSerialInfo(data): Observable<any> {
    return this.post(`/product/check-serial`, data);
  }

  getModelInfo(modelCode): Observable<any> {
    return this.get(`/product/model/${ modelCode }`);
  }

  getSimpleSymptoms(productType): Observable<any> {
    return this.get(`/product/dsr-symptoms/${ productType }`);
  }

  getSymptomsDescription(productType): Observable<any> {
    return this.get(`/product/symptom-description/${ productType }`);
  }

  getFmrIdSearch(params): Observable<any> {
    return this.get(`/fmr/code`, { params });
  }

  getProductHistory(params): Observable<any> {
    const { modelCode, serialNo } = params;
    return this.get(`/product/repair-history/${ modelCode }/${ serialNo }`)
  }
}
